<template>
  <div>
    <b-card
      class="gradient-card"
      style="width: 100%; height: 445px; border-radius: 10px;"
    >
      <div>
        <span style="font-size:20px; color: #fff;">กราฟแสดงสถิติคนข้ามและการกดปุ่ม (วันนี้)</span>
      </div>
      <app-echart-line
        style="height: 400px;"
        :option-data="option"
      />
    </b-card>
  </div>
</template>

<script>
import axios from '@axios'
import {
  BCard, VBModal,
} from 'bootstrap-vue'
import * as echarts from 'echarts'
import Ripple from 'vue-ripple-directive'
import AppEchartLine from './AppEchartLine.vue'

export default {
  components: {
    BCard,
    AppEchartLine,

  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      option: {
        xAxisData: [],
        series: [
          {
            name: 'คมข้าม',
            type: 'line',
            data: [],
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00fbff' },
                { offset: 1, color: 'rgba(4, 22, 22, 0.5)' },
              ]),
            },
            color: '#00fbff',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 2,
            },
          },
          {
            name: 'การกดปุ่ม',
            type: 'line',
            data: [],
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#46ff59' },
                { offset: 1, color: 'rgba(4, 22, 22, 0.5)' },
              ]),
            },
            color: '#46ff59',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 1,
            },
          },
        ],
      },
    }
  },
  computed: {
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getbarSpeed()
    this.interval = setInterval(() => {
      this.getbarSpeed()
    }, 300000)
  },
  methods: {
    getbarSpeed() {
      axios.post('/graphButton', { wid: this.$route.query.wid })
        .then(response => {
          this.xAxisData = []
          this.xAxisData = response.data
          this.option.xAxisData.splice(0)
          this.option.series[0].data.splice(0)
          this.xAxisData.forEach(value => {
            this.option.xAxisData.push(value.Period_Name)
            this.option.series[0].data.push(value.total)
            this.option.series[1].data.push(value.button)
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.gradient-card {
  background:
    linear-gradient(to right, rgba(22, 60, 73, 1) 0%, rgba(22, 52, 73, 0.5) 25%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
    linear-gradient(to left, rgba(22, 60, 73, 1) 0%, rgba(22, 52, 73, 0.5) 25%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
    linear-gradient(to bottom, rgba(22, 60, 73, 0.5) 0%, rgba(22, 52, 73, 0.1) 20%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%),
    linear-gradient(to top, rgba(22, 60, 73, 0.5) 0%, rgba(22, 52, 73, 0.1) 20%, rgba(0,0,0,0) 50%, rgba(0, 111, 30, 0.0) 75%, rgba(0,0,0,0) 100%);
  background-size: 100% 100%, 100% 100%, 100% 100%, 100% 100%;
  background-position: 0 0, 0 100%, 0 0, 100% 0;
  background-repeat: no-repeat;
  border: 1px solid rgb(30, 83, 100, 0.7);
}
// .gradient-card {
//   --square-size: 200%;
//   background:
//     conic-gradient(
//       from 90deg at 50% 50%,
//       rgba(0, 213, 255, 0.6) 0%,
//       rgba(0, 8, 16, 0.7) 25%,
//       rgba(0, 213, 255, 0.6) 50%,
//       rgba(0, 8, 16, 0.7) 75%,
//       rgba(0, 213, 255, 0.6) 100%
//     );
//   background-size: var(--square-size) var(--square-size);
//   mask-image: radial-gradient(
//     var(--square-size) var(--square-size) at 50% 50%,
//     #000 99%,
//     transparent 100%
//   );
//   mask-size: 100% 100%;
// }
</style>
